import React, { Component } from 'react'
import Btn from '../../../../Buttons'
import { Col, Button, OverlayTrigger, Overlay, Tooltip, Popover, Modal } from 'react-bootstrap'
import { ShareButtons, ShareCounts, generateShareIcon } from 'react-share'
import { Link } from 'react-router'
import FormContact from '../../../../../features/commons/ContactForm/ContactForm.container'
import { translate } from 'react-translate'
import { DIST_URL } from '../../../../../constants/api'

@translate('Propiedad')
class ItemList extends Component {

  constructor (props) {
    super(props)

    this.state = {
      showModal: false
    }
    this.changeViewModal = this.changeViewModal.bind(this)
  }

  changeViewModal(e) {
    e.preventDefault()
    e.stopPropagation()
    this.setState({showModal: !this.state.showModal })
  }

  toggle(e) {
    e.preventDefault()
  }

  createTooltip(name) {
    return (<Tooltip id='tooltip-property'><p>{name}</p></Tooltip>)
  }

  _renderCategory (id, categories) {
    let category = categories.filter(function (c) {
      return parseInt(c.id) === id
    })
    return category = (category.length > 0) ? category[0].name : ''
  }

  render () {

    const {
      categories,
      property,
      t
    } = this.props

    let classes = (property.operation_type.name === 'Alquiler') ? 'propiedad-tipo' + ' ' + 'rent' : 'propiedad-tipo' + ' ' + 'sale'
    let location = property.short_address
    // let amount = (property.operation_type.name === 'Alquiler') ? property.rental_currency.name + ' ' + parseInt(property.rental_amount) : property.sale_currency.name + ' ' + parseInt(property.sale_amount)
    let divisa_rental = property.rental_currency.name
		let divisa_sale = property.sale_currency.name
		if (property.rental_currency.name == 'Dolar') {
			divisa_rental = 'u$s'
		}
		if (property.sale_currency.name == 'Dolar') {
			divisa_sale = 'u$s'
		}
		let amount = (property.operation_type.name === 'Alquiler' || property.operation_type.name == 'Alquiler temporario') ? divisa_rental + ' ' + (parseInt(property.rental_amount)).toLocaleString('de-DE') : divisa_sale + ' ' + (parseInt(property.sale_amount)).toLocaleString('de-DE')
    let price

    if((property.category_type_id === 9 || !property.web_price) ||
      ((property.operation_type.name == 'Alquiler' || property.operation_type.name == 'Alquiler temporario') && (property.rental_amount in [0, 1, null, undefined, ''])) ||
      ((property.operation_type.name == 'Venta' || property.operation_type.name == 'Venta/Alquiler') && (property.sale_amount in [0, 1, null, undefined, '']))) {
      price = t('Consultar_precio')
    } else {
      price = amount
    }

    let street = (property.address).toLowerCase()
    let boxOperations = ''
    let generals = [] //array of summary of caracteristics

    if (property.operation_type.name == 'Venta/Alquiler'){
      boxOperations = (
        <div className='wrapper-left'>
          <div className='propiedad-tipo sale'>
            Venta
          </div>
          <div className='propiedad-tipo rent'>
            Alquiler
          </div>
        </div>
      )
    }
    else{
      boxOperations = (
        <div className='wrapper-left'>
          <div className={classes}>
            {property.operation_type.name} nana
          </div>
        </div>
      )
    }

    let hc

    switch (property.property_type.name) {
      case 'Casa' :
      case 'PH':
      case 'Quinta': //housee
        generals = [{value: property.bedrooms, img: DIST_URL+'/assets/images/icons-results/bed.png', overlay: this.createTooltip('Dormitorios')},
                    {value: property.ambients, img: DIST_URL+'/assets/images/icons-results/ambients.png', overlay: this.createTooltip('Ambientes')},
                    {value: ((parseInt(property.land_area)).toLocaleString('de-DE') + ' m2'), img: DIST_URL+'/assets/images/icons-results/ST.png', overlay: this.createTooltip('Superficie Terreno')},
                    {value: ((parseInt(property.covered_area)).toLocaleString('de-DE') + ' m2'), img: DIST_URL+'/assets/images/icons-results/SC.png', overlay: this.createTooltip('Superficie Cubierta')}]
        break
      case 'Departamento' : //apartment
        generals = [{value: property.bedrooms, img: DIST_URL+'/assets/images/icons-results/bed.png', overlay: this.createTooltip('Dormitorios')},
                    {value: property.ambients, img: DIST_URL+'/assets/images/icons-results/ambients.png', overlay: this.createTooltip('Ambientes')},
                    {value: property.garages, img: DIST_URL+'/assets/images/icons-results/garage.png', overlay: this.createTooltip('Estacionamiento')},
                    {value: ((parseInt(property.covered_area)).toLocaleString('de-DE') + ' m2'), img: DIST_URL+'/assets/images/icons-results/SC.png', overlay: this.createTooltip('Superficie Cubierta')}]
        break
      case 'Terreno' : //terreno
        generals = [{value: ((parseInt(property.land_area)).toLocaleString('de-DE') + ' m2'), img: DIST_URL+'/assets/images/icons-results/ST.png', overlay: this.createTooltip('Superficie Terreno')},
                    {value: property.orientation, img: DIST_URL+'/assets/images/icons-results/orientacion.png', overlay: this.createTooltip('Orientación')}]
        break

      case 'Nave Industrial':
      case 'Depósito':
      case 'Galpón': //industry
        generals = [{value: ((parseInt(property.covered_area)).toLocaleString('de-DE') + ' m2'), img: DIST_URL+'/assets/images/icons-results/SC.png', overlay: this.createTooltip('Superficie Cubierta')},
                    {value: ((parseInt(property.land_area)).toLocaleString('de-DE') + ' m2'), img: DIST_URL+'/assets/images/icons-results/ST.png', overlay: this.createTooltip('Superficie Terreno')},
                    {value: property.nave ? parseInt(property.nave) : 0, img: DIST_URL+'/assets/images/icons-results/N.png', overlay: this.createTooltip('Cantidad de Naves')}]
        break

      case 'Chacra':
      case 'Campo':
      case 'Finca': //fields
        hc = (property.land_area) ? property.land_area/10000 : 0
        generals = [{value: parseInt(hc), img: DIST_URL+'/assets/images/icons-results/H.png', overlay: this.createTooltip('Hectáreas')}]
				if(property.aptitude && property.aptitude.length) {
					generals.push({value: property.aptitude[0].name , img: DIST_URL+'/assets/images/icons-results/aptitud.png', overlay: this.createTooltip('Aptitud')})
				}
        break

      case 'Local':
      case 'Fondo de Comercio': //retail
        generals = [{value: ((parseInt(property.covered_area)).toLocaleString('de-DE') + ' m2'), img: DIST_URL+'/assets/images/icons-results/SC.png', overlay: this.createTooltip('Superficie Cubierta')}]
        break

      case 'Oficina':
      case 'Edificio Comercial': //office/buildings
        generals = [{value: categories ? (this._renderCategory(property.category, categories)) : '' , img: DIST_URL+'/assets/images/icons-results/categoria.png', overlay: this.createTooltip('Categoría')},
                    {value: property.garages, img: DIST_URL+'/assets/images/icons-results/garage.png', overlay: this.createTooltip('Estacionamiento')},
                    {value: ((parseInt(property.covered_area)).toLocaleString('de-DE') + ' m2'), img: DIST_URL+'/assets/images/icons-results/SC.png', overlay: this.createTooltip('Superficie Cubierta')}]
        break
    }

    //share with social-networks
    let baseUrl = window.location.origin
    let shareUrl = baseUrl + '/' + property.uri
    const title = 'LJ Ramos'
    let description = property.observations

    const { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } = ShareButtons

    const FacebookIcon = generateShareIcon('facebook')
    const TwitterIcon = generateShareIcon('twitter')
    const LinkedinIcon = generateShareIcon('linkedin')
    const WhatsappIcon = generateShareIcon('whatsapp')

    const popoverShare = (
      <Popover id='popover-share'>
        <WhatsappShareButton
          url={shareUrl}
          title={title}>
          <WhatsappIcon
            size={20}
            round={false} />
        </WhatsappShareButton>
        <FacebookShareButton
          url={shareUrl}
          title={title}
          description={description}
          className=''>
          <FacebookIcon
            size={20}
            round={false} />
        </FacebookShareButton>
        <TwitterShareButton
          url={shareUrl}
          title={title}
          className=''>
          <TwitterIcon
            size={20} />
        </TwitterShareButton>
        <LinkedinShareButton
          url={shareUrl}
          title={title}
          className=''>
          <LinkedinIcon
            size={20} />
        </LinkedinShareButton>
      </Popover>
    )

    return (
      <div>
      	<div className='propiedad-container'>
          <div className='col-md-5 img-list'>
            <Link to={'/' + property.property_code}>
              <div className='propiedad-img'>
                <img src={property.image ? property.image : DIST_URL+'/assets/images/placeholder-list.png' } alt={property.title} title={property.title} />
                <div className='wrapper'>
                  {boxOperations}
                  <div className='wrapper-right'>
                    <div className='propiedad-icons'>
                      <OverlayTrigger trigger='click' rootClose placement='top' overlay={popoverShare}>
                        <Button className='btn-icons' ref='target' onClick={(e) => this.toggle(e)}>
                          <i className='fa fa-share-alt fa-lg'></i>
                        </Button>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className='col-md-7'>
            <div className='propiedad-info'>
              <Link to={'/' + property.property_code}>
                <div className='container-fluid'>
                  <div className='hot-title'>{street}</div>
                  <div className='row'>
                    <div className='info'>
                      <i className='fa fa-map-marker'></i>
                      <h3>{location}</h3>
                    </div>
                  </div>
                  <div className='info price'>
                    <p>{price}</p>
                  </div>
                  <div className='info description'>
                    <p>{property.observations}</p>
                  </div>
                  <div className='info bottom'>
                    <div className='item-left'>
                      {generals.map((item, index) =>
                        ((item.value !== 0) && (item.value !== undefined)) ? (
                          <div className='item-box' key={index}>
                            <h3 className='cant-rooms'>{item.value}</h3>
                            <OverlayTrigger placement='bottom' overlay={item.overlay}>
                              <Button className='btn-fake'><img src={item.img} alt='LJRamos' /></Button>
                            </OverlayTrigger>
                          </div>
                        ) : ''
                      )}
                    </div>
                    <div className='item-right'>
                      <Btn type='submit' text='Contactar' clickButton={(e) => this.changeViewModal(e)} classes='btn-primary btn-propiedad' />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <Modal
          className='modal-contact-form'
          show={this.state.showModal}
          onHide={(e) => this.changeViewModal(e)}
          aria-labelledby='contained-modal-title'
          bsSize='large'
          >
          <Modal.Body>
            <div className='form-box'>
              <div className='form-content form-slider'>
                <Col md={12} sm={12} className='inputs-form form-modal hidden-xs'>
                  <FormContact textareaDefault={false} property={property} />
                </Col>
                <div className='col-md-12 inputs-form visible-xs'>
                  <FormContact textareaDefault={false} property={property} />
                </div>
              </div>
              <div className='box-close'>
                <Button type='submit' onClick={(e) => this.changeViewModal(e)} className='btn-close'>
                  <i className='fa fa-times fa-lg'></i>
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

export default ItemList



// WEBPACK FOOTER //
// ./src/components/Sections/Propiedades/PropiedadesList/List/item.js